export const headers = {
  initialHeaders: [
    {
      title: "CARGO SOLICITADO",
      field: "chargeRequested",
      child: "denomination",
      isRequisition: true,
    },
    { title: "SALARIO", field: "salary", child: null, isRequisition: false },
    {
      title: "REGIONAL",
      field: "regional",
      child: "name",
      isRequisition: true,
    },
    {
      title: "TIPO DE CONTRATO",
      field: "contractType",
      child: null,
      isRequisition: true,
    },
  ],
  otherHeaders: [
    // {
    //   title: "PERFIL DEL CARGO",
    //   field: "chargeApplicant",
    //   child: "denomination",
    //   isRequisition: true,
    // },
    // {
    //   title: "OBSERVACIONES",
    //   field: "observation",
    //   child: null,
    //   isRequisition: false,
    // },
  ],
};

export const defaultSearchValues = {
  regional: '',
  salary: '',
  charge: '',
};

export const defaultJson = [
  {regional: 'Medellin', salario: 1234, cargo: 'Jefe'},
  {regional: 'Medellin', salario: 1234, cargo: 'Jefe'},
  {regional: 'Medellin', salario: 1234, cargo: 'Jefe'},
]